import React from "react";

import * as S from "./ComparisonFlamebearer.styles";
import FlamebearerGraphSkeleton from "./graph/FlamebearerGraphSkeleton";

const ComparisonFlamebearerSkeleton = () => {
  return (
    <S.Layout>
      <S.Row>
        <S.Cell>
          <FlamebearerGraphSkeleton />
        </S.Cell>
        <S.Cell>
          <FlamebearerGraphSkeleton />
        </S.Cell>
      </S.Row>
    </S.Layout>
  );
};

export default ComparisonFlamebearerSkeleton;
